<div class="form-group">
  <div class="from-row">
    <input
      id="competencyNameInput"
      type="text"
      [formControl]="selectedCompetency"
      [ngbTypeahead]="searchCompetency"
      [resultFormatter]="formatter"
      [inputFormatter]="formatter"
      [editable]="false"
      (focus)="competencyFocus$.next($any($event).target.value)"
      (click)="competencyClick$.next($any($event).target.value)"
      (selectItem)="selectChanged($event)"
      (keyup)="checkEmpty()"
      #competencyInstance="ngbTypeahead"
    />
    <fa-icon
      class="remove-icon ms-2"
      [icon]="['fas', 'trash']"
      (click)="delete()"
    ></fa-icon>
  </div>
  <div class="from-row bounds">
    <div class="bound">
      <label for="competencyMinInput">{{ "search_sidebar.competency_input.min" | translate }}</label>
      <select
    id="competencyMinInput"
    class="level-input-box"
    [ngClass]="{ 'bound-error': boundError }"
    [(ngModel)]="lowerBound"
    (click)="$event.stopPropagation()"
    (change)="inputChanged()"
  >
    <option
      *ngFor="
        let competency of employeeCompetencyLevelService.getOptions()
      "
    >
      {{ competency }}
    </option>
  </select>     
    </div>
    <div class="bound">
      <label for="competencyMaxInput">{{ "search_sidebar.competency_input.max" | translate }}</label>
      <select
      id="competencyMaxInput"
      class="level-input-box"
      [ngClass]="{ 'bound-error': boundError }"
      [(ngModel)]="upperBound"
      (click)="$event.stopPropagation()"
      (change)="inputChanged()"
    >
      <option
        *ngFor="
          let competency of employeeCompetencyLevelService.getOptions()
        "
      >
        {{ competency }}
      </option>
    </select>      
    </div>
  </div>
</div>
